import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { Menu } from './menu.model';
import { alphabeticalMenuItems, configMenuItems } from './menu';
import { AuthResponseData } from 'src/app/shared/models/authentication/auth-response-data';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { GlobalFunction } from 'src/app/shared/global-function';
import { LicenseService } from 'src/app/shared/services/license.service';
import { ILicense } from 'src/app/shared/models/license/license.model';
import { observable, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MenuService
{
    private roles: Array<string>;
    private filteredAdminMenu = new Array<Menu>();
    private filteredMenu = new Array<Menu>();
    private authResponseData: AuthResponseData;

    constructor(
        private location: Location,
        private router: Router,
        private licenseService: LicenseService,
        private http: HttpClient
    ) { }

    public getLicense(): Observable<ILicense>
    {

        return this.licenseService.getLicense();
    }



    public getAlphabeticalMenuItems(): Array<Menu>
    {

        let license = this.licenseService.license;
        return this.getLicenseMenu(license, 0);
    }

    public getLicenseMenu(license: ILicense, order: number): Menu[]
    {

        this.filteredMenu = new Array<Menu>();
        this.filteredAdminMenu = new Array<Menu>();
        let userRoles = GlobalFunction.getUserRoles();

        if(order == 0)
        {
            this.filteredAdminMenu = alphabeticalMenuItems;
        }
        else
        {
            this.filteredAdminMenu = configMenuItems;
        }


        // only company settings are displayed for admin with invalid license  
        if (userRoles.findIndex(x => x == "CompanySettings.Edit") > -1)
        {
            if (license === undefined || !this.licenseService.checkIsValidDate())
            {
                this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.routerLink === '/company-settings' || x.title === 'Settings.General.Title');
                return this.filteredAdminMenu
            }
        }


        // remove options that are not part of the license from the menu
        if (license !== undefined)
        {
            if (!license.canUseQFlex)
            {
                this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Settings.Q-Flex.Title' && x.title !== 'Settings.Q-Flex.General.Title' && x.title !== 'Settings.Q-Flex.Workload.Title' && x.title !== 'Settings.Q-Flex.Priorities.Title');
            }

            if (!license.canUseSMSService)
            {
                this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Settings.Notifications.SMS.Title');
            }

            if(!license.canViewAllAppointments)
            {
                this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Appointments.All.Title');
            }

            if(!license.canViewGroupAppointments)
            {
                this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Appointments.Group.Title');
            }
        } 
        else
        {
            // no valid license!
            this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Settings.Q-Flex.Title' && x.title !== 'Settings.Q-Flex.General.Title' && x.title !== 'Settings.Q-Flex.Workload.Title' && x.title !== 'Settings.Q-Flex.Priorities.Title');
            this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Settings.Notifications.SMS.Title');
            this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Appointments.All.Title');
            this.filteredAdminMenu = this.filteredAdminMenu.filter(x => x.title !== 'Appointments.Group.Title');
        }

        
        for (let index = 0; index < this.filteredAdminMenu.length; index++)
        {
            let roles = this.filteredAdminMenu[index].role.split(",");

            roles.forEach(role =>
            {
                role = role.trim(); // trim is required because there can be spaces before the claim names due to the split and how someone entered it to the vertical menu.
                if (role === "")   // no precondition required --> anyone can see this
                {
                    this.filteredMenu.push(this.filteredAdminMenu[index]);
                }
                else
                {
                    let indexRole = userRoles.findIndex(x => x == role);
                    if (indexRole !== -1)
                    {
                        if (this.filteredMenu.indexOf(this.filteredAdminMenu[index]) < 0)   // only add the menu if it isnt already there. Needed when multiple roles of the same menu are fullfilled
                        {
                            this.filteredMenu.push(this.filteredAdminMenu[index]);
                        }
                    }
                }
            });
        }

        return this.filteredMenu;

    }



    public expandActiveSubMenu(menu: Array<Menu>)
    {
        let url = this.location.path();
        let routerLink = url; // url.substring(1, url.length);
        let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
        if (activeMenuItem[0])
        {
            let menuItem = activeMenuItem[0];
            while (menuItem.parentId != 0)
            {
                let parentMenuItem = menu.filter(item => item.id == menuItem.parentId)[0];
                menuItem = parentMenuItem;
                this.toggleMenuItem(menuItem.id);
            }
        }
    }

    public toggleMenuItem(menuId)
    {
        let menuItem = document.getElementById('menu-item-' + menuId);
        let subMenu = document.getElementById('sub-menu-' + menuId);
        if (subMenu)
        {
            if (subMenu.classList.contains('show'))
            {
                subMenu.classList.remove('show');
                menuItem.classList.remove('expanded');
            }
            else
            {
                subMenu.classList.add('show');
                menuItem.classList.add('expanded');
            }
        }
    }

    public closeOtherSubMenus(menu: Array<Menu>, menuId)
    {
        let currentMenuItem = menu.filter(item => item.id == menuId)[0];
        if (currentMenuItem.parentId == 0 && !currentMenuItem.target)
        {
            menu.forEach(item =>
            {
                if (item.id != menuId)
                {
                    let subMenu = document.getElementById('sub-menu-' + item.id);
                    let menuItem = document.getElementById('menu-item-' + item.id);
                    if (subMenu)
                    {
                        if (subMenu.classList.contains('show'))
                        {
                            subMenu.classList.remove('show');
                            menuItem.classList.remove('expanded');
                        }
                    }
                }
            });
        }
    }

    public getEnableIntegrationServer(): Observable<any>
    {
        return this.http.get<boolean>(AppConfigService.appConfig.WebAPIServer + "/api/getEnableIntegrationServer")
    }


}
